import React from 'react';
import classNames from 'classnames';
import './LoadingOverlay.css';
import { CircularProgress, getLuminance } from '@material-ui/core';
import { useBodyBackgroundColor } from '@facet-wealth/design';

const LoadingOverlay = () => {
  const bodyBackgroundColor = useBodyBackgroundColor();
  const shouldBeWhiteOverlay = getLuminance(bodyBackgroundColor) < 0.92;
  return (
    <div className={classNames('loading-overlay', { 'loading-overlay-white': shouldBeWhiteOverlay })}>
      <div>
        <CircularProgress />
      </div>
    </div>
  );
};

export default LoadingOverlay;
